import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";

interface LoadingProps {
  className?: string;
  size?: "sm" | "default" | "lg";
  text?: string;
}

export function Loading({ className, size = "default", text }: LoadingProps) {
  const sizeClasses = {
    sm: "h-4 w-4",
    default: "h-8 w-8",
    lg: "h-12 w-12",
  };

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-2",
        className,
      )}
    >
      <Loader2 className={cn("animate-spin text-primary", sizeClasses[size])} />
      {text && (
        <p
          className={cn("text-primary animate-pulse", {
            "text-sm": size === "sm",
            "text-base": size === "default",
            "text-lg": size === "lg",
          })}
        >
          {text}
        </p>
      )}
    </div>
  );
}
